import React from 'react';
import { Paper, Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Faq = () => {
  return (
    <Box>
        <Paper elevation={3} sx={{ p: 3, width: '100%' }}>
      <Typography variant="h6" gutterBottom>
        Frequently Asked Questions
      </Typography>

      <Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>How secure is my data on "Share a Secret"?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            On "Share a Secret," all secrets are encrypted before being stored on our servers. We do not store any keys, so we cannot decrypt the data. Your secrets are secure and private.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Does "Share a Secret" store my IP address or any other personal data?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            No, we do not store IP addresses or personal data from our users. Your privacy is our top priority.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Who can see my secrets?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            Only the people you share the secret link with can access the secret. The link is the only way to view the secret.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>How does encryption work on "Share a Secret"?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            Your secrets are encrypted with a randomly generated key before being stored on our servers. Since we do not store the key, we cannot decrypt or view your data.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>How long will my secrets be stored?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            Your secrets will remain stored as long as you specify or until the maximum read count is reached. After that, or when the limit is exceeded, the secret will no longer be accessible.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>What happens to secrets that have not been accessed in the last 30 days?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
        Secrets that have not been accessed in the last 30 days will be automatically deleted as part of our regular cleanup process. This applies even if the secret has not reached its maximum read count. The cleanup process considers the "last accessed" date, and once 30 days have passed without access, the secret will be deleted.

Please note that this does not affect secrets with a "valid at" date set. If a secret has a "valid at" date, it cannot be accessed until that date, and the last accessed time will only update once the secret is successfully opened.

This cleanup mechanism helps maintain security by removing inactive or stale secrets while respecting any set "valid at" restrictions, as well as considering the max read count.</Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Do I need to register to use "Share a Secret"?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            No, you can use the service completely anonymously and without registration. Just enter your secret, it will be encrypted, and a link will be created.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Could "Share a Secret" view my secret?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            No, we have no access to your secrets. All data is encrypted, and without the associated key, we cannot decrypt it.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Can I share the link to my secret with others?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            Yes, you can share the link with others as long as the link is valid and the secret has not been read.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>What happens if I lose the link to my secret?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            If you lose the link, you can no longer access the secret because we do not store the key and therefore cannot decrypt it.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>How does "Share a Secret" delete my secrets?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            Your secrets are automatically deleted once they reach the maximum read count or the expiration date. After that, the data is no longer accessible.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Can I revoke access to my secret?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            No, once you create the link, the secret remains accessible until it is read or expired. There is no way to revoke access because we do not store the access.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Who has access to the secret link?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            Only you and the people you share the secret link with can access the secret. Without the link, no one can view the content.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Can I protect my secret with a password?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            Currently, we do not offer password protection as the service is fully anonymous and no personal data is stored. Access is only through the secret link.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Are my secrets permanently secure?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            Yes, since we do not store the keys or unencrypted data, your secret remains permanently secure as long as the link is not shared or made public.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Can I store multiple secrets at once?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            Yes, you can create as many secrets as you want, each with a unique link. However, each link has its own validity and read count.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>What happens if the secret is opened too many times?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography>
            Once the maximum read count is reached, the secret becomes inaccessible. It can no longer be retrieved.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Do I need to verify my email before viewing a secret?</Typography>
    </AccordionSummary>
    <AccordionDetails>
        <Typography paragraph>
            "Require Email Authentication" is an optional security feature. When enabled, the viewer must enter a valid email address and click a verification link sent to that inbox before the secret unlocks — adding an extra layer of protection beyond the link itself.
        </Typography>
        <Typography paragraph>
            <strong>Any email vs. a specific email:</strong> By default, anyone who has the link can verify their own email address to open the secret. If you want to lock it down further, you can optionally enter a single "Allowed Email" when creating the secret — then only that exact address can view it.
        </Typography>
        <Typography paragraph>
            <strong>Other limits still apply:</strong> Email authentication works on top of your other settings. The maximum read count, one-time use, and expiry dates are all still enforced, so the secret still self-destructs as configured.
        </Typography>
        <Typography paragraph>
            <strong>Session:</strong> Verification is tied to your browser session. If the session ends (for example, the browser is closed), you will need to verify again.
        </Typography>
        <Typography>
            <strong>Email storage:</strong> Verification is handled by our authentication provider. Addresses are used solely to validate access and inactive accounts are automatically cleaned up.
        </Typography>
    </AccordionDetails>
</Accordion>

<Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Can I edit a secret after it's created?</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          No, secrets cannot be edited after creation. If you need to change a secret, you'll need to delete the old one (by letting it expire or be read) and create a new one.
        </Typography>
      </AccordionDetails>
    </Accordion>

    {/* NEU: Ist Share a Secret Open Source? */}
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Is "Share a Secret" open source?</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          We plan to open source parts of our project in the future. This will allow transparency in how we handle data and encryption. Stay tuned for updates.
        </Typography>
      </AccordionDetails>
    </Accordion>

    {/* NEU: Welche Datentypen darf ich teilen? */}
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>What types of data can I safely share using this service?</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          You can safely share any sensitive text such as passwords, API keys, or short confidential notes. Please avoid uploading personally identifiable information or illegal content, as this violates our terms of use.
        </Typography>
      </AccordionDetails>
    </Accordion>

    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Is there a limit on how long my secret can be?</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          Yes, each secret can be up to 500 characters long. This is ideal for passwords, API keys, and short confidential notes. For anything larger, share it as a link to a secured file instead.
        </Typography>
      </AccordionDetails>
    </Accordion>

    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>What is the difference between "Maximum Read Count" and "One Time Secret"?</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          "Maximum Read Count" lets the secret be opened a set number of times before it is deleted. "One Time Secret" is a stricter shortcut that deletes the secret immediately after it is viewed once. Use One Time Secret when only a single recipient should ever see it.
        </Typography>
      </AccordionDetails>
    </Accordion>

    <Accordion>
  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
    <Typography>Can I use "Share a Secret" via an API?</Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Typography>
      Yes, we provide a public API that allows you to create secret links programmatically. We also offer ready-to-use modules for popular environments like <strong>Node.js</strong> and <strong>PowerShell</strong> to make integration easy.
    </Typography>
  </AccordionDetails>
</Accordion>
      </Paper>
    </Box>
  );
};

export default Faq;
